module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "txba"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "toc-ct"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Intro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Our Angry World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("Chapter 1: DEFINITIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Anger: The Good, the Bad, and the Destructive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: EXPRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("The Three Ways Anger Is Manifested")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: CONSEQUENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Anger’s Impact on Us, Others, and God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: ROOTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Exploring the Causes of Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: RELEASE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Letting Go of Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: CURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("The Balm for Anger: Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: REBELLION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Anger Aimed at God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: PEACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Establishing Personal Peace in an Angry World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: RELATIONSHIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Living with Angry People—or Not")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: CHARACTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Establishing Peace in Yourself and"), _c('br'), _vm._v("Training Your Children in Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: CONFLICT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("Confronting Conflict in a Godly Manner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: PURPOSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("A Case Study of God-Engineered Conflict")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: OPPORTUNITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("The Potential for Personal Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_c('em', [_vm._v("If You Are Not a Christian …")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0